var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('video',{ref:"video",class:_vm.properties.behavior ? _vm.properties.behavior : '',style:(_vm.videoStyle),attrs:{"src":_vm.videoSrc,"id":"video"}})}
var staticRenderFns = []

export { render, staticRenderFns }